import { gql } from "@apollo/client";

export const START_MANUAL_SENTRY_SESSION_MUTATION = gql`
    mutation StartManualSentrySession(
        $durationMinutes: Int
        $doubleSentry: Boolean
        $sendChatMessage: Boolean
    ) {
        startManualSentrySession(
            durationMinutes: $durationMinutes
            doubleSentry: $doubleSentry
            sendChatMessage: $sendChatMessage
        ) {
            success
            sessionId
            message
        }
    }
`;
